
import * as __star__ from '@clayui/popover';

const {
default: __default__,
Popover,
__esModule
} = __star__;

export {
Popover,
__esModule
};
export default __default__;
